export const letterB = {
  nouns: [
    {"train station": ["Bahnhof", "Bahnhöfe", "der", "die", "m"]},
    {"bath": ["Bad", "Bäder", "das", "die", "n"]},
    {"tree": ["Baum", "Bäume", "der", "die", "m"]},
    {"example": ["Beispiel", "Beispiele", "das", "die", "n"]},
    {"mountain": ["Berg", "Berge", "der", "die", "m"]},
    {"flower": ["Blume", "Blumen", "die", "die", "f"]},
    {"book": ["Buch", "Bücher", "das", "die", "n"]},
    {"brother": ["Bruder", "Brüder", "der", "die", "m"]},
    {"bank/bench": ["Bank", "Banken", "die", "die", "f"]},
    {"profession": ["Beruf", "Berufe", "der", "die", "m"]},
    {"baby": ["Baby", "Babys", "das", "die", "n"]},
    {"bakery": ["Bäckerei", "Bäckereien", "die", "die", "f"]},
    {"railway": ["Bahn", "Bahnen", "die", "die", "f"]},
    {"platform": ["Bahnsteig", "Bahnsteige", "der", "die", "m"]},
    {"balcony": ["Balkon", "Balkone", "der", "die", "m"]},
    {"banana": ["Banane", "Bananen", "die", "die", "f"]},
    {"stomach": ["Bauch", "Bäuche", "der", "die", "m"]},
    {"civil servant": ["Beamte", "Beamten", "der", "die", "m"]},
    {"leg": ["Bein", "Beine", "das", "die", "n"]},
    {"acquaintance": ["Bekannte", "Bekannten", "der", "die", "m"]},
    {"bed": ["Bett", "Betten", "das", "die", "n"]},
    {"beer": ["Bier", "Biere", "das", "die", "n"]},
    {"picture": ["Bild", "Bilder", "das", "die", "n"]},
    {"pear": ["Birne", "Birnen", "die", "die", "f"]},
    {"request": ["Bitte", "Bitten", "die", "die", "f"]},
    {"pencil": ["Bleistift", "Bleistifte", "der", "die", "m"]},
    {"gaze": ["Blick", "Blicke", "der", "die", "m"]},
    {"sheet": ["Bogen", "Bögen", "der", "die", "m"]},
    {"letter": ["Brief", "Briefe", "der", "die", "m"]},
    {"stamp": ["Briefmarke", "Briefmarken", "die", "die", "f"]},
    {"bread": ["Brot", "Brote", "das", "die", "n"]},
    {"bread roll": ["Brötchen", "Brötchen", "das", "die", "n"]},
    {"letter": ["Buchstabe", "Buchstaben", "der", "die", "m"]},
    {"bus": ["Bus", "Busse", "der", "die", "m"]},
    {"butter": ["Butter", "Butter", "die", "die", "f"]}
  ],
  verbs: [
    {"to begin": ["beginnen", "beginne", "beginnst", "beginnt", "beginnt", "beginnt", "beginnen", "beginnt", "beginnen", "beginnen"]},
    {"to need": ["brauchen", "brauche", "brauchst", "braucht", "braucht", "braucht", "brauchen", "braucht", "brauchen", "brauchen"]},
    {"to visit": ["besuchen", "besuche", "besuchst", "besucht", "besucht", "besucht", "besuchen", "besucht", "besuchen", "besuchen"]},
    {"to get, to receive": ["bekommen", "bekomme", "bekommst", "bekommt", "bekommt", "bekommt", "bekommen", "bekommt", "bekommen", "bekommen"]},
    {"to bathe": ["baden", "bade", "badest", "badet", "badet", "badet", "baden", "badet", "baden", "baden"]},
    {"to mean": ["bedeuten", "bedeute", "bedeutest", "bedeutet", "bedeutet", "bedeutet", "bedeuten", "bedeutet", "bedeuten", "bedeuten"]},
    {"to order": ["bestellen", "bestelle", "bestellst", "bestellt", "bestellt", "bestellt", "bestellen", "bestellt", "bestellen", "bestellen"]},
    {"to pay": ["bezahlen", "bezahle", "bezahlst", "bezahlt", "bezahlt", "bezahlt", "bezahlen", "bezahlt", "bezahlen", "bezahlen"]},
    {"to ask": ["bitten", "bitte", "bittest", "bittet", "bittet", "bittet", "bitten", "bittet", "bitten", "bitten"]},
    {"to stay": ["bleiben", "bleibe", "bleibst", "bleibt", "bleibt", "bleibt", "bleiben", "bleibt", "bleiben", "bleiben"]},
    {"to bring": ["bringen", "bringe", "bringst", "bringt", "bringt", "bringt", "bringen", "bringt", "bringen", "bringen"]},
    {"to spell": ["buchstabieren", "buchstabiere", "buchstabierst", "buchstabiert", "buchstabiert", "buchstabiert", "buchstabieren", "buchstabiert", "buchstabieren", "buchstabieren"]}
  ],
  examples: {
    nominative: [
      {
        german: '___ Bahnhof ist neu.',
        english: 'The train station is new.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Blume ist schön.',
        english: 'The flower is beautiful.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Buch ist interessant.',
        english: 'The book is interesting.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Berg ist hoch.',
        english: 'The mountain is high.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Beispiel ist klar.',
        english: 'The example is clear.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Baby schläft.',
        english: 'The baby is sleeping.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Bäckerei hat Brot.',
        english: 'The bakery has bread.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Bank ist groß.',
        english: 'The bank is large.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Bruder kommt.',
        english: 'The brother is coming.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Bier ist kalt.',
        english: 'The beer is cold.',
        answer: 'Das',
        case: 'nominative'
      }
    ],
    accusative: [
      {
        german: 'Ich sehe ___ Berg.',
        english: 'I see the mountain.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie liest ___ Buch.',
        english: 'She reads the book.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Er braucht ___ Beruf.',
        english: 'He needs the profession.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Wir besuchen ___ Bahnhof.',
        english: 'We visit the train station.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Du kaufst ___ Blume.',
        english: 'You buy the flower.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er bestellt ___ Brief.',
        english: 'He orders the letter.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie bezahlt ___ Bier.',
        english: 'She pays for the beer.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Ich bringe ___ Bruder.',
        english: 'I bring the brother.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Wir kaufen ___ Brot.',
        english: 'We buy the bread.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Du liest ___ Buch.',
        english: 'You read the book.',
        answer: 'das',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich helfe ___ Bruder.',
        english: 'I help the brother.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie geht zu ___ Bank.',
        english: 'She goes to the bank.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er gibt ___ Kind ___ Buch.',
        english: 'He gives the child the book.',
        answer: 'dem das',
        case: 'dative'
      },
      {
        german: 'Wir sprechen über ___ Beruf.',
        english: 'We speak about the profession.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Du sitzt auf ___ Bank.',
        english: 'You sit on the bench.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er hilft ___ Bekannten.',
        english: 'He helps the acquaintance.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie dankt ___ Bäckerei.',
        english: 'She thanks the bakery.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Ich gebe ___ Bruder ___ Buch.',
        english: 'I give the brother the book.',
        answer: 'dem das',
        case: 'dative'
      },
      {
        german: 'Wir sprechen mit ___ Beamten.',
        english: 'We speak with the civil servant.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Du schreibst ___ Brief.',
        english: 'You write the letter.',
        answer: 'dem',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The train station is new.',
        german: 'Der Bahnhof ist neu.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The flower is beautiful.',
        german: 'Die Blume ist schön.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She reads the book.',
        german: 'Sie liest das Buch.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I help the brother.',
        german: 'Ich helfe dem Bruder.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'They sit on the bench.',
        german: 'Sie sitzen auf der Bank.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'The baby is small.',
        german: 'Das Baby ist klein.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We need a book.',
        german: 'Wir brauchen ein Buch.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The civil servant works.',
        german: 'Der Beamte arbeitet.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'You write a letter.',
        german: 'Du schreibst einen Brief.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'He brings the bread.',
        german: 'Er bringt das Brot.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The mountain is high.',
        german: 'Der Berg ist hoch.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She sits on the bench.',
        german: 'Sie sitzt auf der Bank.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'We begin the work.',
        german: 'Wir beginnen die Arbeit.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The beer is cold.',
        german: 'Das Bier ist kalt.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'I thank the bakery.',
        german: 'Ich danke der Bäckerei.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'The brother has a profession.',
        german: 'Der Bruder hat einen Beruf.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'They visit the train station.',
        german: 'Sie besuchen den Bahnhof.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The flower blooms.',
        german: 'Die Blume blüht.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'You pay for the bread.',
        german: 'Du bezahlst für das Brot.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I ask for the book.',
        german: 'Ich bitte um das Buch.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'They stay at home.',
        german: 'Sie bleiben zu Hause.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She bathes the baby.',
        german: 'Sie badet das Baby.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The example means everything.',
        german: 'Das Beispiel bedeutet alles.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We need a pencil.',
        german: 'Wir brauchen einen Bleistift.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'He brings the letter.',
        german: 'Er bringt den Brief.',
        type: 'translation',
        caseType: 'accusative'
      }
    ],
    conjugations: [
      {
        question: 'How do you conjugate "to need" for "I"?',
        answer: 'brauche',
        verb: 'brauchen',
        verbEnglish: 'to need',
        subject: 'ich',
        conjugation: 'brauche'
      },
      {
        question: 'How do you conjugate "to visit" for "you" (informal)?',
        answer: 'besuchst',
        verb: 'besuchen',
        verbEnglish: 'to visit',
        subject: 'du',
        conjugation: 'besuchst'
      },
      {
        question: 'How do you conjugate "to get" for "he"?',
        answer: 'bekommt',
        verb: 'bekommen',
        verbEnglish: 'to get, to receive',
        subject: 'er',
        conjugation: 'bekommt'
      },
      {
        question: 'How do you conjugate "to begin" for "we"?',
        answer: 'beginnen',
        verb: 'beginnen',
        verbEnglish: 'to begin',
        subject: 'wir',
        conjugation: 'beginnen'
      },
      {
        question: 'How do you conjugate "to need" for "they"?',
        answer: 'brauchen',
        verb: 'brauchen',
        verbEnglish: 'to need',
        subject: 'sie',
        conjugation: 'brauchen'
      },
      {
        question: 'What is the simple past of "to need" for "I"?',
        answer: 'brauchte',
        verb: 'brauchen',
        verbEnglish: 'to need',
        subject: 'ich',
        conjugation: 'brauchte'
      },
      {
        question: 'What is the simple past of "to visit" for "she"?',
        answer: 'besuchte',
        verb: 'besuchen',
        verbEnglish: 'to visit',
        subject: 'sie',
        conjugation: 'besuchte'
      },
      {
        question: 'What is the simple past of "to get" for "he"?',
        answer: 'bekam',
        verb: 'bekommen',
        verbEnglish: 'to get, to receive',
        subject: 'er',
        conjugation: 'bekam'
      },
      {
        question: 'What is the simple past of "to begin" for "we"?',
        answer: 'begannen',
        verb: 'beginnen',
        verbEnglish: 'to begin',
        subject: 'wir',
        conjugation: 'begannen'
      },
      {
        question: 'How do you conjugate "to bathe" for "I"?',
        answer: 'bade',
        verb: 'baden',
        verbEnglish: 'to bathe',
        subject: 'ich',
        conjugation: 'bade'
      },
      {
        question: 'How do you conjugate "to mean" for "he"?',
        answer: 'bedeutet',
        verb: 'bedeuten',
        verbEnglish: 'to mean',
        subject: 'er',
        conjugation: 'bedeutet'
      },
      {
        question: 'How do you conjugate "to order" for "she"?',
        answer: 'bestellt',
        verb: 'bestellen',
        verbEnglish: 'to order',
        subject: 'sie',
        conjugation: 'bestellt'
      },
      {
        question: 'How do you conjugate "to pay" for "I"?',
        answer: 'bezahle',
        verb: 'bezahlen',
        verbEnglish: 'to pay',
        subject: 'ich',
        conjugation: 'bezahle'
      },
      {
        question: 'How do you conjugate "to ask" for "he"?',
        answer: 'bittet',
        verb: 'bitten',
        verbEnglish: 'to ask',
        subject: 'er',
        conjugation: 'bittet'
      },
      {
        question: 'How do you conjugate "to stay" for "we"?',
        answer: 'bleiben',
        verb: 'bleiben',
        verbEnglish: 'to stay',
        subject: 'wir',
        conjugation: 'bleiben'
      },
      {
        question: 'How do you conjugate "to bring" for "she"?',
        answer: 'bringt',
        verb: 'bringen',
        verbEnglish: 'to bring',
        subject: 'sie',
        conjugation: 'bringt'
      },
      {
        question: 'How do you conjugate "to spell" for "I"?',
        answer: 'buchstabiere',
        verb: 'buchstabieren',
        verbEnglish: 'to spell',
        subject: 'ich',
        conjugation: 'buchstabiere'
      }
    ]
  }
}
